import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Card as CardP } from './CardProps';
import { format } from 'date-fns';
import { getDate } from '../../configInfo/components/Functions';
import Divider from '@mui/material/Divider';

interface Props {
  card: CardP;
  onCardClick: (sessionUid: string) => any;
  delay: number;
}

const SessionCard: React.FC<Props> = ({ card, onCardClick, delay }) => {
  let dateCreated = format(getDate(new Date(card.createdUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');
  let dateLastUpdate = format(getDate(new Date(card.lastUpdatedUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');
  let dateSessionExpired = format(getDate(new Date(card.sessionExpirationUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');

  return (
    <div
      className="card"
      onClick={() => {
        onCardClick(card.sessionUid);
      }}>
      <Card sx={{ cursor: 'pointer' }}>
        <CardContent>
          <Typography variant="h6">
            <b>Email: </b>
            {card.email}
          </Typography>
          <Typography variant="h6">
            <b>Config Name: </b>
            {card.configName}
          </Typography>
          <Divider />
          <br></br>
          <Typography variant="body1">
            <b>Application UId: </b>
            {card.sessionUid}
          </Typography>
          <Typography variant="body1">
            <b>Created: </b>
            {dateCreated}
          </Typography>
          <Typography variant="body1">
            <b>Last Updated: </b>
            {dateLastUpdate}
          </Typography>
          <Typography variant="body1">
            <b>OnDemand Config Id: </b>
            {card.onDemandConfigId}
          </Typography>
          <Typography variant="body1">
            <b>Current Subflow Name: </b>
            {card.currentSubflowName}
          </Typography>
          <Typography variant="body1">
            <b>Current Subflow Id: </b>
            {card.currentSubflowId}
          </Typography>
          <Typography variant="body1">
            <b>Current Phase Name: </b>
            {card.currentPhaseName}
          </Typography>
          <Typography variant="body1">
            <b>Current Phase Id: </b>
            {card.currentPhaseId}
          </Typography>
          <Typography variant="body1">
            <b>Current Status: </b>
            {card.latestStatus}
          </Typography>
          <Typography variant="body1">
            <b>Current Status Detail: </b>
            {card.latestStatusDetails}
          </Typography>
          <Typography variant="body1">
            <b>Application Expired Date: </b>
            {dateSessionExpired}
          </Typography>
          <Typography variant="body1">
            <b>AA Id: </b>
            {card.aaid} {card.partnerName || '' }
          </Typography>
          <Typography variant="body1">
            <b>Affiliate Id: </b>
            {card.affiliateId}
          </Typography>
          <Typography variant="body1">
            <b>{card.isEmailVerified ? 'Email Verified' : 'Email Not Verified'}</b>
          </Typography>
          <Typography variant="body1">
            <b>Email Verdict: </b>
            {card.emailVerdict}
          </Typography>
          <Typography variant="body1">
            <b>{card.isOptedOut ? 'Opted Out' : 'Opted In'}</b>
          </Typography>
          <Typography variant="body1">
            <b>{card.isDisqualified ? 'Disqualified' : 'Not Disqualified'}</b>
          </Typography>
          <Typography variant="body1">
            <b>{card.isCompleted ? 'Completed' : 'Not Completed'}</b>
          </Typography>
          <Typography variant="body1">
            <b>{card.isLeadConverted ? 'Lead is Converted' : 'Lead Not Converted'}</b>
          </Typography>
          <Typography variant="body1">
            <b>Company Name JSON:</b>
            <pre>{JSON.stringify(JSON.parse(card.companyNameJson), null, 2)}</pre>
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default SessionCard;
